import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { formatLongDate } from '../../../../utils/date-formatters';

@Component({
  selector: 'cv-transcription-date',
  standalone: true,
  imports: [NgOptimizedImage],
  template: `
    @if (date) {
      <div class="transcription__date">
        <div class="transcription__date-label">
          <img ngSrc="assets/icons/phone-solid.svg" priority alt="phone icon" height="15" width="15" />
          Conversation Began
        </div>
        <div>{{ date }}</div>
      </div>
    }
  `,
  styleUrl: './transcription-date.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranscriptionDateComponent {
  @Input({ transform: formatLongDate }) date: string = '';
}
